import styled from 'styled-components';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { NO_EXPORT_CLASS_NAME } from '@ardoq/global-consts';
import { colors } from '@ardoq/design-tokens';

export const UrlFieldValueIcon = styled(Icon).attrs({
  iconName: IconName.OPEN_IN_NEW,
  iconSize: IconSize.SMALL,
  className: NO_EXPORT_CLASS_NAME,
})`
  margin-left: auto;
  pointer-events: auto;
  color: ${colors.iconStrong};
  flex-shrink: 0;
`;
